export function accountReturnPath(value: string | null): string {
  if (!value || value.length > 2048 || !value.startsWith('/')) return '/';
  try {
    const decoded = decodeURIComponent(value);
    if (/^\/[\\/]/.test(decoded) || /[\\\r\n]/.test(decoded)) return '/';
    const url = new URL(value, 'https://internal.invalid');
    if (url.origin !== 'https://internal.invalid' || /^\/(account|login|admin)(\/|$)/.test(url.pathname)) return '/';
    return url.pathname + url.search + url.hash;
  } catch { return '/'; }
}
